import React from "react";
import { TextInputField } from "../../../common-components";
import BuzzCard from "../buzz-card/BuzzCard";

const BuzzFeed = ({ buzzDisplay, display, height, liveFeed, historyFeed }) => {
  const checkLayout = () => {
    let liveFeedDateSort = liveFeed.sort(
      (a, b) =>
        new Date(...a.editedOn.split("/").reverse()) -
        new Date(...b.editedOn.split("/").reverse())
    );
    liveFeedDateSort = liveFeedDateSort.reverse();
    return liveFeedDateSort;
  };

  const checkLayoutHistory = () => {
    let liveFeedDateSort = historyFeed.sort(
      (a, b) =>
        new Date(...a.editedOn.split("/").reverse()) -
        new Date(...b.editedOn.split("/").reverse())
    );
    liveFeedDateSort = liveFeedDateSort.reverse();
    return liveFeedDateSort;
  };

  const postTypeSplit = (postType) => {
    const splitArray = postType.split(",");

    return splitArray;
  };

  const tagsSplit = (tags) => {
    const splitArray = tags.split(",");

    return splitArray;
  };
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        overflowY: "auto",
        maxHeight:
          height > 400
            ? height > 600
              ? height > 750
                ? 650
                : 600
              : 500
            : 400,
        minHeight: display ? 350 : 0,
        transition: "all 0.4s",
        overflowX: "hidden",
        marginTop: 5,
      }}
    >
      {" "}
      {/* <div style={{ width: "100%" }}>
        <BuzzCard
          buzzTitle={"SOME TITLE"}
          senderTitle={"SENDER DETAILS"}
          longDescription={"some description thats long wnded"}
          postType={"BOLO"}
          sourceLink={"link"}
          tagsData={["tags", "tags", "tags", "tags"]}
          option2={true}
        />
      </div> */}
      {buzzDisplay === "today"
        ? liveFeed
          ? checkLayout().map((post, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <BuzzCard
                    buzzTitle={post.title}
                    senderTitle={post.senderDetails}
                    quickDescription={post.shortDescription}
                    longDescription={post.longDescription}
                    postType={postTypeSplit(post.postType[0])[0]}
                    subPostType={postTypeSplit(post.postType[0])[1]}
                    sourceLink={post.sourceLink}
                    tagsData={tagsSplit(post.tags[0])}
                    option2={true}
                    postId={post.postId}
                  />
                </div>
              );
            })
          : null
        : null}
      {buzzDisplay === "myPin"
        ? historyFeed
          ? checkLayoutHistory().map((post, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <BuzzCard
                    buzzTitle={post.title}
                    senderTitle={post.senderDetails}
                    quickDescription={post.shortDescription}
                    longDescription={post.longDescription}
                    postType={postTypeSplit(post.postType[0])[0]}
                    subPostType={postTypeSplit(post.postType[0])[1]}
                    sourceLink={post.sourceLink}
                    tagsData={post.tags}
                    option2={true}
                    postId={post.postId}
                  />
                </div>
              );
            })
          : null
        : null}
      <div style={{ padding: 40 }} />
    </div>
  );
};

export default BuzzFeed;
